import './style.css';
import { renderApp } from './render';
import { bindThemeToggles } from './theme';

const root = document.getElementById('app');

if (!root) {
  throw new Error('#app root element not found');
}

renderApp(root);
bindThemeToggles();
